module.exports = __webpack_public_path__ + "img/schemeList04.8f241256.jpg";